// extracted by mini-css-extract-plugin
export default {"tabsContainer":"GalleryImageTab_tabsContainer__g5Tfj","tabItem":"GalleryImageTab_tabItem__QBK5A","active":"GalleryImageTab_active__drlAO"};